// All Mixpanel event names in one place
export const EVENTS = {
  PAGE_VIEW: "Page View",
  LINK_CLICK: "Link Click",
  NAVIGATION: "Navigation",
  FORM_SUBMIT_CLICK: "Form Submit Click",
  FORM_SUBMITTED: "Form Submitted",
};
